/* eslint-disable no-console */
/* eslint-disable no-plusplus */
import { takeLatest, select, putResolve, call, race, delay, put } from 'redux-saga/effects';
import filter from 'lodash/filter.js';
import map from 'lodash/map.js';
import _findLast from 'lodash/findLast.js';
import safeSaga from '../safeSaga';
import {
  INITIATE_ADD_ITEM_TO_BUNDLE,
  START_REMOVE_ITEM_FROM_BUNDLE,
  CREATE_PURCHASED_LOGO,
  CREATE_PURCHASED_LOGO_FAILED,
  CREATE_ORDER_LINEITEM_LOGO,
  ADD_PREV_LOGO_TO_NEWLINEITEM,
  ADD_LIQUIDPIXEL_UPDATED_LOGO,
} from '../../actions/orderSummaryActions/actionTypes';
import {
  CREATE_DESIGN_SUCCESS,
  CREATE_ITEM_SUCCESS,
  CREATE_CONFIG_SUCCESS,
  CREATE_CONFIG_FAILED,
  CREATE_DESIGN_FAILED,
  CREATE_ITEM_FAILED,
  CREATE_ITEM_PRODUCT_FAILED,
} from '../../actions/designActions/actionTypes';
import {
  completeAddItemToBundle,
  addOrderSummary,
  removeItemInBundleFromStore,
  createOrderLineItemLogo,
  createOrderLineItemLogoFailed,
  addPrevLogoToNewLineItem,
  addLiquidPixelUpdatedLogo,
  completeLiquidPixelUpdatedLogo,
  startRemoveItemFromBundle,
  addLiquidPixelLogoFailed,
  lineItemNotToBeRemoved,
  createPurchasedLogoFailed,
  addPrevLogoToNewLineFailed,
  skuExists,
} from '../../actions/orderSummaryActions';
import {
  createItemStart,
  createItemProductStart,
  createConfigStart,
} from '../../actions/designActions';
import {
  currentSelectedItems,
  removeItem,
  updatePreviousSelectedItems,
  updateMultipleItem,
} from '../../actions/multipleLineItem/multipleLinePricing';
import { getPricing } from '../../actions/pricingActions';
import {
  currentItemQuantitySelector,
  configuratorSelector,
  designContentSelector,
  orderSummarySelector,
  currentSelectedItemSelector,
  previousmultipleLineIemSelector,
} from '../../selectors';
import { showErrorToast } from '../../components/orderSummary/OrderSummaryToast';
import { trackErrorInteractions } from '../../utils/analytics/trackEvents';
import { getSku } from '../../actions/getSkuMap';
import { getPricingForItemsInBundle } from '../pricingSaga/getLineItemPricing';
import { getPrintUploadsLogoImages } from '../../utils/visualizerUtils';
import {
  copyLogoApi,
  addPrevLogoToNewLineItemApi,
  updateLiquidPixelLogoToS3Api,
} from '../../api/eleanorApi';
import { removePpeLineItemFromS3 } from '../../api/removePpeLineItemApi';
import {
  recordStormDoorAction,
  APP_ACTION_ATB_FAIL,
  CONTEXT_ATB_CONFIG_FAIL,
  CONTEXT_ATB_FAIL,
  APP_ACTION_CREATE_CONFIG_FAIL,
  APP_ACTION_CREATE_PURCHASED_LOGO_FAILED,
  recordPpeAddToCartCreateItemOrderSummarySagaFailure,
  recordPpeAddToCartCreateConfigurationOrderSummarySagaFailure,
  recordPpeStartRemoveFromBundleOrderSummarySagaFailure,
  recordPpeMergeBundleOrderSummarySagaFailure,
  recordPpeAddItemToBundleStartSagaFailure,
  recordPpeCreatePurchasedLogoFailure,
  recordPpeCreateOrderLogoFailure,
  recordPpeCopyPreviousLogoToNewLineItemFailure,
  recordPpeUpdateLiquidPixelLogoToS3Failure,
} from '../../utils/newRelic';
import getExpConfig from '../../utils/getExpConfig';
import { updateCopyLogo } from '../../actions/uploadImages';

const filterSelections = (choice, options, choices) => {
  const option = options[choice.optionId];
  if (choice.isSelected && option.isDependent) {
    const parentChoice = choices[option.parentChoiceId];
    if (parentChoice.isSelected && option.isActive && choice.isActive) {
      return filterSelections(parentChoice, options, choices);
    }
    return false;
  }

  return choice.isSelected && choice.isActive && option.isActive;
};

const getSelections = (choices, options) =>
  filter(choices, (choice) => filterSelections(choice, options, choices)).map((item) => {
    const option = options[item.optionId];
    if (option === null) {
      throw new Error(`Error building selections: can't find option with ID:${item.optionId}`);
    }
    return {
      optionId: item.optionId,
      choiceId: item.id,
      choiceValue: item.value,
      optionType: option.optionType,
      optionTags: option.tags,
    };
  });

export function* addToCartCreateItem() {
  // Step 2 - create item
  const { containerId, design } = yield select(designContentSelector);
  try {
    if (!design) {
      // invalid
      return;
    }
    yield putResolve(createItemStart({ containerId }));
  } catch (err) {
    recordPpeAddToCartCreateItemOrderSummarySagaFailure(err, design.designId, containerId);
  }
}

export function* addToCartCreateConfiguration() {
  const { design, newItem } = yield select(designContentSelector);
  const { orderSummaryItems } = yield select(orderSummarySelector);
  if (!design || !newItem) {
    // invalid
    return;
  }
  try {
    if (newItem.length === orderSummaryItems.length) {
      yield putResolve(createConfigStart());
    }
  } catch (err) {
    if (err) {
      const errorObject = {
        type: 'system',
        displayType: 'page',
        pageSection: 'Configuration',
        message: err.response.statusText || 'An Internal Error has Occurred',
        code: err.response.status || 'API did not respond',
      };
      trackErrorInteractions(errorObject, 'error', 'post page error');
    }
    recordPpeAddToCartCreateConfigurationOrderSummarySagaFailure(
      err,
      design.designId,
      newItem,
      orderSummaryItems
    );
  }
}

export function* addToCartCreateItemProduct() {
  // Step 4 - create item product
  const { design, newItem, newConfiguration } = yield select(designContentSelector);
  if (!design || !newItem || !newConfiguration) {
    // invalid
    return;
  }
  const customData = [];
  newConfiguration.map((newConfig, key) =>
    customData.push({
      designId: design.designId,
      itemId: newItem[key].itemId,
      configurationGuid: newConfig.configurationGuid,
    })
  );
  yield putResolve(createItemProductStart(customData));
}

function* checkSku(skus, stateData = []) {
  const currentSkus = {};
  let existentId = 0;
  let prevQuantity = 0;
  let Guid = 0;
  let skuExist = false;
  if (stateData.length) {
    const lineItems = yield stateData.filter((lineItem) => lineItem.pricingId);
    for (let i = 0; i < lineItems.length; i += 1) {
      const { sku, id, quantity, pricingId } = yield lineItems[i];
      if (!currentSkus[sku.sku]) currentSkus[sku.sku] = [id, quantity, pricingId];
    }
    if (currentSkus[skus.sku]) {
      skuExist = true;
      [existentId, prevQuantity, Guid] = currentSkus[skus.sku];
    }
  }
  return {
    skuExist,
    prevQuantity,
    existentId,
    Guid,
  };
}

export function* startRemoveFromBundle(payload) {
  const { id } = payload.payload;
  const {
    orderSummary: { orderSummaryItems },
  } = yield select();
  try {
    const item = orderSummaryItems.find((orderSummaryItem) => orderSummaryItem.id === id);
    const params = {
      lineItemId: item?.pricingId,
      uploadType: `${getExpConfig('amazon-s3-environment-path')}Order`,
    };
    yield putResolve(removeItemInBundleFromStore({ id }));
    yield call(removePpeLineItemFromS3, params);
    yield call(getPricingForItemsInBundle, false);
  } catch (error) {
    recordPpeStartRemoveFromBundleOrderSummarySagaFailure(error, id, orderSummaryItems);
  }
}

function* mergeBundle(summaryItems, id, userId) {
  const truthy = true;
  try {
    const lines = summaryItems.filter((lineItem) => lineItem.pricingId);

    const item = lines.find((line) => line.id === id);
    const params = {
      lineItemId: item?.pricingId,
      uploadType: `${getExpConfig('amazon-s3-environment-path')}Order`,
    };

    /** the following order matter a lot for adding/merging the same configuration(s)
    to bundle and updating any related API or async actions */
    yield putResolve(lineItemNotToBeRemoved({ truthy }))
    yield putResolve(startRemoveItemFromBundle({ id }));
    yield putResolve(removeItemInBundleFromStore({ id }));
    yield putResolve(removeItem(userId));
    yield call(removePpeLineItemFromS3, params);
    yield call(getPricingForItemsInBundle, false);
  } catch (error) {
    recordPpeMergeBundleOrderSummarySagaFailure(error, summaryItems, id, userId);
  }
}

export function* addItemToBundleStart({ payload }) {
  const { id, updatedCurrentselection } = payload;
  const {
    product: {
      details: {
        attributes: { ppeProductType },
      },
    },
    config: { partnerProductId },
    configurator: { choices, options },
    uploadImages: { uploadImages },
  } = yield select();

  try {
    const falsy = false;
    const selections = getSelections(choices, options);
    const printUploadLogoImages = getPrintUploadsLogoImages(uploadImages, ppeProductType);
    const orderQty = yield select(currentItemQuantitySelector);
    const configurator = yield select(configuratorSelector);
    const { orderSummaryItems } = yield select(orderSummarySelector);
    const { skus } = yield putResolve(getSku());
    

    const { skuExist, prevQuantity, existentId, Guid } = yield call(
      checkSku,
      skus[0],
      orderSummaryItems
    );
    let mergedQty = yield orderQty;
    yield (mergedQty += prevQuantity);
  
    yield putResolve(updateCopyLogo({
      isCopyLogo: true
    }));
    yield putResolve(lineItemNotToBeRemoved({ falsy }))
    yield putResolve(skuExists(skuExist))
    yield putResolve(addOrderSummary());
    yield putResolve(createOrderLineItemLogo());
    yield putResolve(
      completeAddItemToBundle({
        id,
        quantity: mergedQty,
        partnerProductId,
        name: configurator?.productInfo?.siteProductName,
        selections,
        sku: skus[0],
        printUploadLogoImages,
      })
    );

    // after  adding to bundle we need to update previousSelections and multipleItem
  
        if (skuExist) {
          const { currentSelectedItem } = yield select(currentSelectedItemSelector);
          const selectedGuid = currentSelectedItem[0].uniqueIdentifier;
          yield putResolve(updatePreviousSelectedItems({ selectedGuid, mergedQty }));
          const { previousSelections } = yield select(previousmultipleLineIemSelector);
          const mergedData = [...previousSelections, ...currentSelectedItem];
          yield putResolve(updateMultipleItem(mergedData));
        }

        yield call(getPricingForItemsInBundle, true);
        yield putResolve(currentSelectedItems(updatedCurrentselection));
        yield putResolve(getPricing());
        yield putResolve(addPrevLogoToNewLineItem());
        yield putResolve(addLiquidPixelUpdatedLogo());

        if (skuExist) {
          yield call(mergeBundle, orderSummaryItems, existentId, Guid);
        }  
  } catch (error) {
    recordPpeAddItemToBundleStartSagaFailure(error, payload, uploadImages, partnerProductId);
  }
}

function failedToAddItemToCart() {
  recordStormDoorAction(APP_ACTION_ATB_FAIL, 'Add to Bundle Fail', CONTEXT_ATB_FAIL);
  showErrorToast('Unable to Add to Cart');
}

function failedToAddItemToCartConfig() {
  recordStormDoorAction(
    APP_ACTION_CREATE_CONFIG_FAIL,
    'Create Configuration Fail',
    CONTEXT_ATB_CONFIG_FAIL
  );
}

export function* createPurchasedLogo() {
  const {
    orderSummary: { orderSummaryItems },
  } = yield select();
  try {
    const lineItemIds = orderSummaryItems.map((lineItemId) => lineItemId.pricingId);
    const data = {
      sourceUploadType: `${getExpConfig('amazon-s3-environment-path')}Order`,
      destinationUploadType: `${getExpConfig('amazon-s3-environment-path')}Purchased`,
      lineItemIds,
    };
  
    const response = yield call(copyLogoApi, data);
    if(!response && response !== undefined){
      yield putResolve(createPurchasedLogoFailed(response));
    }
  } catch (error) {
    yield putResolve(createPurchasedLogoFailed(error));
    yield recordPpeCreatePurchasedLogoFailure(error, orderSummaryItems);
  }
}

export function* copyLocalToOrderLogo() {
  const {
    multipleLineItem: { currentSelectedItem },
  } = yield select();

  try {
    const lineItemIds = currentSelectedItem.map((lineItemId) => lineItemId.uniqueIdentifier);
    const data = {
      sourceUploadType: `${getExpConfig('amazon-s3-environment-path')}Local`,
      destinationUploadType: `${getExpConfig('amazon-s3-environment-path')}Order`,
      lineItemIds,
    };
    const response = yield call(copyLogoApi, data);
    if(!response && response !== undefined){
      yield putResolve(createOrderLineItemLogoFailed(response));
    }

  } catch (error) {
    yield putResolve(createOrderLineItemLogoFailed(error));
    yield recordPpeCreateOrderLogoFailure(error, currentSelectedItem);
    yield putResolve(updateCopyLogo({
      isCopyLogo: false
    }));
  }
}

export function* copyPrevLogoToNewLineItem() {
  const {
    multipleLineItem: { currentSelectedItem, previousSelections },
  } = yield select();
  try {
    const SourceLineItemId = _findLast(
      previousSelections,
      (lineItemId) => lineItemId.uniqueIdentifier
    ).uniqueIdentifier;
    const DestinationLineItemId = currentSelectedItem.map(
      (lineItemId) => lineItemId.uniqueIdentifier
    );
    const data = {
      SourceUploadType: `${getExpConfig('amazon-s3-environment-path')}Local`,
      SourceLineItemId,
      DestinationUploadType: `${getExpConfig('amazon-s3-environment-path')}Local`,
      DestinationLineItemId: DestinationLineItemId ? DestinationLineItemId[0] : 0,
    };
    const response= yield call(addPrevLogoToNewLineItemApi, data);
    if(!response){
      yield putResolve(addPrevLogoToNewLineFailed(true));
    }
  } catch (error) {
    yield putResolve(addPrevLogoToNewLineFailed(error))
    recordPpeCopyPreviousLogoToNewLineItemFailure(error, currentSelectedItem);
  }
}


export function* updateLiquidPixelLogoToS3() {
  const {
    orderSummary: { orderSummaryItems },
  } = yield select();

  try {
    const PrintUploadLogoImages = _findLast(
      orderSummaryItems,
      (lineItemId) => lineItemId.printUploadLogoImages
    ).printUploadLogoImages;
    const DestinationLineItemId = _findLast(
      orderSummaryItems,
      (lineItemId) => lineItemId.pricingId
    ).pricingId;

    const AddLiquidPixelImageModel = map(PrintUploadLogoImages, (value, key) => ({
      Url: value,
      LogoPosition: key,
      DestinationUploadType: `${getExpConfig('amazon-s3-environment-path')}Order`,
      DestinationLineItemId,
      DestinationPPEFileType: 'Updated',
    }));

    const returnUrls = yield call(updateLiquidPixelLogoToS3Api, AddLiquidPixelImageModel);
    if(Object.keys(returnUrls).length){
      yield putResolve(completeLiquidPixelUpdatedLogo(returnUrls));
    } else {
      yield putResolve(addLiquidPixelLogoFailed(true));
    }
    yield putResolve(updateCopyLogo({
      isCopyLogo: false
    }));
  } catch(error) {
      yield putResolve(addLiquidPixelLogoFailed(true));
      yield recordPpeUpdateLiquidPixelLogoToS3Failure(error, orderSummaryItems);
    }
}

export default function* orderSummarySaga() {
  yield takeLatest(START_REMOVE_ITEM_FROM_BUNDLE, safeSaga(startRemoveFromBundle));
  yield takeLatest([INITIATE_ADD_ITEM_TO_BUNDLE], safeSaga(addItemToBundleStart));
  yield takeLatest(CREATE_DESIGN_SUCCESS, safeSaga(addToCartCreateItem));
  yield takeLatest(CREATE_ITEM_SUCCESS, safeSaga(addToCartCreateConfiguration));
  yield takeLatest(CREATE_CONFIG_SUCCESS, safeSaga(addToCartCreateItemProduct));
  yield takeLatest([CREATE_CONFIG_FAILED], safeSaga(failedToAddItemToCartConfig));

  yield takeLatest(
    [CREATE_DESIGN_FAILED, CREATE_ITEM_FAILED, CREATE_CONFIG_FAILED, CREATE_ITEM_PRODUCT_FAILED],
    safeSaga(failedToAddItemToCart)
  );
  yield takeLatest(CREATE_PURCHASED_LOGO, safeSaga(createPurchasedLogo));
  yield takeLatest(CREATE_ORDER_LINEITEM_LOGO, safeSaga(copyLocalToOrderLogo));
  yield takeLatest(ADD_PREV_LOGO_TO_NEWLINEITEM, safeSaga(copyPrevLogoToNewLineItem));
  yield takeLatest(ADD_LIQUIDPIXEL_UPDATED_LOGO, safeSaga(updateLiquidPixelLogoToS3));
}
